import { render } from "./EmptyFavorite.vue?vue&type=template&id=481bffee"
import script from "./EmptyFavorite.vue?vue&type=script&lang=js"
export * from "./EmptyFavorite.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\matress-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__